<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="labForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="lab" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                labForm: () => import('../forms/LabForm'),
                lab: () => import('../editViews/Lab'),
                headers: [
                    { text: 'Name', value: 'name' },
                    { text: 'Coordinates', value: 'coordinates', format: this.formatCoordinates },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                ],
                itemsField: 'labs',
                editPageName: 'lab',
                apiMethod: 'Labs',
                claimName: 'Labs',
                formTitle: 'Lab',
                excelTitle: 'Labs',
                hasEditPage: true,
            }
        },
    };
</script>
